var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBlissful = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  className: "blissful_svg___icon_7rbmn_1",
  width: "1em",
  height: "1em",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  className: "blissful_svg__Blissful blissful_svg__24"
}, /*#__PURE__*/React.createElement("g", {
  className: "blissful_svg__SVG"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#FFC220",
  className: "blissful_svg__Fill-Main"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.5,
  fillRule: "evenodd",
  d: "M5.293 15.293a1 1 0 0 1 1.414 0 7.485 7.485 0 0 0 10.586 0 1 1 0 0 1 1.414 1.414 9.485 9.485 0 0 1-13.414 0 1 1 0 0 1 0-1.414Z",
  className: "blissful_svg__Fill-Secondary",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF6334",
  fillRule: "evenodd",
  d: "M5.16 7c.936 0 1.532.511 1.84.88.308-.369.904-.88 1.84-.88C10.046 7 11 7.985 11 8.96c0 .974-.536 1.737-1.61 2.615-.879.72-1.284.908-1.933 1.208-.14.065-.292.135-.462.217a30.985 30.985 0 0 0-.467-.221c-.638-.298-1.043-.488-1.918-1.204C3.537 10.697 3 9.935 3 8.96 3 7.985 3.955 7 5.16 7Zm10 0c.936 0 1.532.511 1.84.88.308-.369.904-.88 1.84-.88C20.046 7 21 7.985 21 8.96c0 .974-.536 1.737-1.61 2.615-.879.72-1.284.908-1.933 1.208-.14.065-.292.135-.462.217a31.266 31.266 0 0 0-.467-.221c-.638-.298-1.043-.488-1.918-1.204C13.537 10.697 13 9.935 13 8.96c0-.975.955-1.96 2.16-1.96Z",
  className: "blissful_svg__Fill-Accent",
  clipRule: "evenodd"
})))));
export default SvgBlissful;